import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SmartAssistantFeedFilterDTO } from '../../../dtos/glai.dto';
import {
  FilterList,
  FilterType,
} from '../../applied-filters/applied-filters.dto';

@Component({
  selector: 'app-smart-assistant-filter-container',
  standalone: false,
  templateUrl: './smart-assistant-filter-container.component.html',
  styleUrl: './smart-assistant-filter-container.component.scss',
})
export class SmartAssistantFilterContainerComponent {
  @Input() smartAssistantFeedFilters: SmartAssistantFeedFilterDTO;

  @Output() readonly filterRemoved: EventEmitter<string> = new EventEmitter();

  @Output() readonly filterListRemoved: EventEmitter<FilterList> =
    new EventEmitter();

  removeFilter(keyName: string) {
    this.filterRemoved.emit(keyName);
  }

  removeFilterFromList(keyName: string, value: FilterType) {
    this.filterListRemoved.emit({
      keyName,
      value,
    });
  }
}
